import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ContentChildren, NgModule } from '@angular/core';
import * as i1 from '@eui/components/legacy/ux-tabs-bar';
import { UxTabsBarComponentModule } from '@eui/components/legacy/ux-tabs-bar';
import { UxTabComponent } from '@eui/components/legacy/ux-tab';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

// tom:
// 1. The ux-tabs component as it was designed before mixed different features/responsibilities: managing static
//    <ux-tab> elements, and actually displaying tabs for representing them.
// 2. the actual displaying of tabs has been moved to <asm-ux-simple-tabs>
// 3. The management of the static <ux-tab> elements is done here
// 4. no longer possible to pass in an array of UxTab objects -> mixed usage (before) wasn't going to work anyway
// 5. handling of visibility, activeness, order, ... should be handled in this component.
// 6. activeTabIndex property makes no sense, should use isActive on <ux-tab>
class UxStaticTabsComponent {
    constructor() {
        this._isMainNavigation = false;
        this._isSubTabs = false;
        // @Input() activeTabIndex: number; // tom: i'm not sure if this makes sense. If you want to
        // activate a tab you should use the [isActive] attribute on the <ux-tab> element
        this.tabSelected = new EventEmitter();
        this.tabClosed = new EventEmitter();
        this.e2eAttr = 'ux-static-tabs';
        this.tabs = [];
    }
    get isMainNavigation() { return this._isMainNavigation; }
    set isMainNavigation(value) { this._isMainNavigation = coerceBooleanProperty(value); }
    get isSubTabs() { return this._isSubTabs; }
    set isSubTabs(value) { this._isSubTabs = coerceBooleanProperty(value); }
    ngAfterContentInit() {
        this.tabs = this._filterChildren();
        // this._autoSelect();
    }
    ngOnChanges(changes) {
        // if (changes.activeTabIndex) {
        //     this._autoSelect();
        // }
    }
    onSelectTab(tab) {
        if (!tab.isDisabled) {
            this._selectTab(tab);
        }
    }
    onCloseTab(closedTab) {
        let nextTab;
        if (closedTab.isActive) {
            const closedTabIndex = this.tabs.indexOf(closedTab);
            const isSelectableTab = (tab) => !tab.isDisabled;
            nextTab = this.tabs
                .slice(closedTabIndex + 1)
                .find(isSelectableTab)
                || this.tabs
                    .slice(0, closedTabIndex)
                    .reverse()
                    .find(isSelectableTab);
            closedTab.isActive = false;
        }
        closedTab.isVisible = false;
        this.tabs = this._filterChildren(); // removes closedTab from tabs
        this.tabClosed.emit(closedTab);
        // select alternative tab
        if (nextTab) {
            this._selectTab(nextTab);
        }
    }
    _selectTab(tab) {
        if (tab) {
            this.tabs = this.tabs
                .filter(_tab => _tab.isVisible)
                .map(_tab => {
                _tab.isActive = (_tab === tab);
                return _tab;
            });
            this.tabSelected.emit(tab);
        }
    }
    _filterChildren() {
        const _tabs = this.childrenTabs
            .filter(childTab => childTab.isVisible);
        // tom: if you want to change the order of the tabs based on the index attribute of the child-elements you
        // could sort them here.
        // you could perform a check/set isActive before returning the new array
        return _tabs;
    }
}
/** @nocollapse */ UxStaticTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxStaticTabsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxStaticTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxStaticTabsComponent, selector: "ux-static-tabs", inputs: { styleClass: "styleClass", isMainNavigation: "isMainNavigation", isSubTabs: "isSubTabs", e2eAttr: "e2eAttr" }, outputs: { tabSelected: "tabSelected", tabClosed: "tabClosed" }, queries: [{ propertyName: "childrenTabs", predicate: UxTabComponent }], usesOnChanges: true, ngImport: i0, template: `
        <ux-tabs-bar [tabs]="tabs"
                     [styleClass]="styleClass"
                     [isMainNavigation]="isMainNavigation"
                     [isSubTabs]="isSubTabs"
                     (tabSelected)="onSelectTab($event)"
                     (tabClosed)="onCloseTab($event)"
                     attr.data-e2e="{{ e2eAttr }}">
            <ng-content></ng-content>
        </ux-tabs-bar>
    `, isInline: true, dependencies: [{ kind: "component", type: i1.UxTabsBarComponent, selector: "ux-tabs-bar", inputs: ["styleClass", "tabs", "isMainNavigation", "isSubTabs", "e2eAttr"], outputs: ["tabSelected", "tabClosed"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxStaticTabsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ux-static-tabs',
                    template: `
        <ux-tabs-bar [tabs]="tabs"
                     [styleClass]="styleClass"
                     [isMainNavigation]="isMainNavigation"
                     [isSubTabs]="isSubTabs"
                     (tabSelected)="onSelectTab($event)"
                     (tabClosed)="onCloseTab($event)"
                     attr.data-e2e="{{ e2eAttr }}">
            <ng-content></ng-content>
        </ux-tabs-bar>
    `
                }]
        }], propDecorators: { styleClass: [{
                type: Input
            }], isMainNavigation: [{
                type: Input
            }], isSubTabs: [{
                type: Input
            }], tabSelected: [{
                type: Output
            }], tabClosed: [{
                type: Output
            }], e2eAttr: [{
                type: Input
            }], childrenTabs: [{
                type: ContentChildren,
                args: [UxTabComponent]
            }] } });
class UxStaticTabsComponentModule {
}
/** @nocollapse */ UxStaticTabsComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxStaticTabsComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxStaticTabsComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxStaticTabsComponentModule, declarations: [UxStaticTabsComponent], imports: [CommonModule, UxTabsBarComponentModule], exports: [UxStaticTabsComponent] });
/** @nocollapse */ UxStaticTabsComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxStaticTabsComponentModule, imports: [CommonModule, UxTabsBarComponentModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxStaticTabsComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, UxTabsBarComponentModule],
                    exports: [UxStaticTabsComponent],
                    declarations: [UxStaticTabsComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxStaticTabsComponent, UxStaticTabsComponentModule };
